var _circle, _path, _path2, _path3, _path4, _path5, _path6, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCohortsImg(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 427,
    height: 493,
    viewBox: "0 0 427 493",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 201.665,
    cy: 291.796,
    r: 179.665,
    fill: "#14AE78"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M280.555 385.812C280.555 397.75 271.613 407.418 260.57 407.418H133.168C122.137 407.418 113.191 397.746 113.191 385.812V190.996C113.191 179.047 122.141 169.379 133.168 169.379H260.57C271.613 169.379 280.555 179.047 280.555 190.996V385.812Z",
    fill: "#F4AE7F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M197.699 199.051C197.699 201.32 193.176 203.156 187.621 203.156H123.281C117.711 203.156 113.196 201.32 113.196 199.051V162.098C113.196 159.836 117.707 158 123.281 158H187.621C193.176 158 197.699 159.836 197.699 162.098V199.051Z",
    fill: "#F4AE7F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M290.523 376.75C290.523 386.879 281.492 395.07 270.34 395.07H141.594C130.457 395.07 121.41 386.875 121.41 376.75V211.633C121.41 201.512 130.457 193.312 141.594 193.312H270.34C281.492 193.312 290.523 201.516 290.523 211.633V376.75Z",
    fill: "#D0D2D3"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M290.523 363.836C290.523 373.965 281.492 382.156 270.34 382.156H141.594C130.457 382.156 121.41 373.961 121.41 363.836V198.719C121.41 188.598 130.457 180.406 141.594 180.406H270.34C281.492 180.406 290.523 188.602 290.523 198.719V363.836Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M245.359 190.344C245.359 191.562 239.352 192.555 231.961 192.555H146.414C139.008 192.555 133 191.562 133 190.344V170.441C133 169.211 139.008 168.23 146.414 168.23H231.961C239.352 168.23 245.359 169.211 245.359 170.441V190.344Z",
    fill: "#D0D2D3"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M155.398 228.43H266.969C274.477 228.43 274.477 217.883 266.969 217.883H155.398C147.918 217.883 147.918 228.43 155.398 228.43ZM155.398 249.855H266.969C274.477 249.855 274.477 239.316 266.969 239.316H155.398C147.918 239.316 147.918 249.855 155.398 249.855ZM155.398 271.75H266.969C274.477 271.75 274.477 261.203 266.969 261.203H155.398C147.918 261.203 147.918 271.75 155.398 271.75ZM155.398 293.156H266.969C274.477 293.156 274.477 282.617 266.969 282.617H155.398C147.918 282.617 147.918 293.156 155.398 293.156ZM155.398 334.484H206.758C214.242 334.484 214.242 323.941 206.758 323.941H155.398C147.918 323.938 147.918 334.484 155.398 334.484Z",
    fill: "#35494D"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_2709_2071)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M381.33 291.733C381.33 390.959 300.891 471.398 201.665 471.398C102.439 471.398 22 390.959 22 291.733C22 192.507 106.58 391.442 205.806 391.442C305.032 391.442 381.33 192.507 381.33 291.733Z",
    fill: "#14AE78"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_2709_2071",
    x: 0.799999,
    y: 218.8,
    width: 425.73,
    height: 273.798,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 12,
    dy: -12
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 16.6
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2709_2071"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2709_2071",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCohortsImg);
export default __webpack_public_path__ + "static/media/cohortsImg.116f80e1ea3325a6dd799b935bd490b4.svg";
export { ForwardRef as ReactComponent };